import { Contract } from 'ethers'
import { useActiveWeb3React } from 'hooks'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { getFactoryContract } from 'utils'
import { MEDIA_WIDTHS } from '../../theme'

const KycFrame = styled.div`
  margin-bottom: 32px;
  max-width: 640px;
  width: 100%;
`
const KycContainer = styled.div`

  margin: 0 auto;
  max-width: ${MEDIA_WIDTHS.upToLarge}px;
  border-radius: 8px;

  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.08);

  padding: 16px 20px
  border: solid 1px #224765;

  background-image: linear-gradient(to bottom, #11314a, #0c2539);

  
`
const NoKycText = styled.div`
  color: #dfb64c;
`

export default function KycStatus() {
  const { account, chainId, library } = useActiveWeb3React()
  const [kycStatus, setKycStatus] = useState<boolean | null>(null)

  const checkKycStatus = async (contract: Contract) => {
    try {
      const status = await contract.hasValidKyc()
      console.log('KYC Status:', status)
      setKycStatus(status)
    } catch (error) {
      console.error('KYC Status Error:', error)
      setKycStatus(false)
    }
  }

  useEffect(() => {
    if (account && chainId && library) {
      const contract = getFactoryContract(chainId, library, account)
      if (contract) checkKycStatus(contract)
    }
  }, [account, chainId, library])

  if (!account || !chainId || !library || kycStatus === null) return null

  // return <h2>{kycStatus === null ? 'Checking KYC status...' : kycStatus ? 'KYC valid.' : 'KYC invalid!'}</h2>

  if (!kycStatus) {
    return (
      <KycFrame>
        <KycContainer>
          <NoKycText>
            Your DID address does not have a valid KYC status. Please complete KYC to access all features.
          </NoKycText>
        </KycContainer>
      </KycFrame>
    )
  }

  return null
}
